import React, { Component } from "react";
import { Row, Column } from "react-foundation";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";

import { saveContactDetails, sendQuoteRequest } from "../../actions";

import Logo from "components/Logo";
import ThemeButton from "../../components/ThemeButton";
import SimpleFormField from "../../components/SimpleFormField";
import { sendEnquiryToApi } from "./apiService";

class ContactDetails extends Component {
    constructor(props) {
        super(props);
        this.state = { submitting: false };
    }

    async onSubmit(values) {
        if (this.state.submitting) return;

        const params = sessionStorage.getItem("params");
        console.log(params);

        this.setState({ submitting: true });

        // Step 1: Save contact details to Redux store
        // Step 2: Run sendQuoteRequest (SaveEnquiry → BatchPriceEnquiry) so that
        //         pricedEnquiries are written to sessionStorage BEFORE we call the CRM API.
        this.props.saveContactDetails(values, () => {
            this.props.sendQuoteRequest(true, null, async (pricedEnquiries) => {
                // Step 3: Send to ICAAL CRM with the per-installer priced enquiry data
                const apiKey = sessionStorage.getItem("apiKey");
                const apiResult = await sendEnquiryToApi(values, this.props, apiKey, params, pricedEnquiries);

                if (!apiResult.success) {
                    console.error("API submission failed:", apiResult.error);
                    // Don't block navigation — the TruFrame quote was already sent
                }

                if (apiResult.skipped) {
                    console.log(apiResult.message);
                } else {
                    console.log("CRM form submitted!", apiResult.data);
                }

                this.props.history.push("/GetQuote/Thanks");
            });
        });
    }

    render() {
        return (
            <div style={{ position: "relative" }}>
                <Logo topLeft={true} />
                <Row className="top-padding-page">
                    <Column small={10} medium={8} large={6} centerOnSmall>
                        <h3>About You</h3>
                        <p>Please fill in your details and a quote will be emailed to you.</p>
                    </Column>
                    <Column small={12}>
                        <form onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                            <Row>
                                <Column
                                    small={8}
                                    medium={6}
                                    large={4}
                                    centerOnSmall
                                    style={{ textAlign: "left" }}
                                >
                                    <Field name="name" component={SimpleFormField} autoFocus={true}>
                                        Your name:
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    small={8}
                                    medium={6}
                                    large={4}
                                    centerOnSmall
                                    style={{ textAlign: "left" }}
                                >
                                    <Field name="email" component={SimpleFormField}>
                                        Email:
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    small={8}
                                    medium={6}
                                    large={4}
                                    centerOnSmall
                                    style={{ textAlign: "left" }}
                                >
                                    <Field name="telephone" component={SimpleFormField}>
                                        Telephone:
                                    </Field>
                                </Column>
                            </Row>
                            <Row className={this.props.Customer.Type === "Other" ? "" : "hide"}>
                                <Column
                                    small={8}
                                    medium={6}
                                    large={4}
                                    centerOnSmall
                                    style={{ textAlign: "left" }}
                                >
                                    <Field name="postcode" component={SimpleFormField}>
                                        Postcode:
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    small={8}
                                    medium={6}
                                    large={4}
                                    centerOnSmall
                                    style={{ textAlign: "left" }}
                                >
                                    <p
                                        style={{
                                            fontSize: "0.7em",
                                            marginTop: 5,
                                            marginBottom: 5,
                                        }}
                                    >
                                        We’ll only use this information to allow your chosen
                                        approved supplier to get in touch with you, and allow you to
                                        access your quote again in the future.
                                    </p>
                                    <Field name="TandC" type="checkbox" component={SimpleFormField}>
                                        {"I agree with QuoteBuilder's "}
                                        <a
                                            href="http://www.doubleglazingnetwork.com/terms-conditions/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Terms and Conditions
                                        </a>
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    small={8}
                                    medium={6}
                                    large={4}
                                    centerOnSmall
                                    style={{ textAlign: "left" }}
                                >
                                    <p
                                        style={{
                                            fontSize: "0.7em",
                                            marginTop: 5,
                                            marginBottom: 5,
                                        }}
                                    ></p>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    small={8}
                                    medium={6}
                                    large={4}
                                    centerOnSmall
                                    style={{ textAlign: "left" }}
                                >
                                    <Field
                                        name="consentCommunication"
                                        type="checkbox"
                                        component={SimpleFormField}
                                    >
                                        I agree for my chosen suppliers to contact me.
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    small={8}
                                    medium={6}
                                    large={4}
                                    centerOnSmall
                                    style={{ textAlign: "left" }}
                                >
                                    <p
                                        style={{
                                            fontSize: "0.7em",
                                            marginTop: 5,
                                            marginBottom: 5,
                                        }}
                                    >
                                        We may wish to also contact you for marketing purposes. If
                                        you consent please choose how we can contact you below:
                                    </p>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    small={8}
                                    medium={6}
                                    large={4}
                                    centerOnSmall
                                    style={{ textAlign: "left" }}
                                >
                                    <Field
                                        name="consentMarketingEmails"
                                        type="checkbox"
                                        component={SimpleFormField}
                                    >
                                        Email
                                    </Field>
                                </Column>
                            </Row>
                            <Row>
                                <Column
                                    small={8}
                                    medium={6}
                                    large={4}
                                    centerOnSmall
                                    style={{ textAlign: "left" }}
                                >
                                    <Field
                                        name="consentMarketingPhone"
                                        type="checkbox"
                                        component={SimpleFormField}
                                    >
                                        Telephone
                                    </Field>
                                </Column>
                            </Row>

                            <ThemeButton
                                className={this.state.submitting ? "button-submitting" : ""}
                            >
                                SUBMIT
                            </ThemeButton>
                        </form>
                    </Column>
                </Row>
            </div>
        );
    }
}

const validate = (values, props) => {
    let errors = {};

    if (!values.name) errors.name = "Required";
    if (!values.email) errors.email = "Required";
    if (!values.postcode && props.Customer.Type === "Other") errors.postcode = "Required";
    if (!values.TandC) errors.TandC = "Required";
    if (!values.consentCommunication) errors.consentCommunication = "Required";
    if (values.consentMarketingPhone && !values.telephone) errors.telephone = "Required";

    return errors;
};

const mapStateToProps = (state) => {
    return {
        Customer: state.TradeCustomer,
    };
};

export default connect(mapStateToProps, { saveContactDetails, sendQuoteRequest })(
    reduxForm({
        form: "contactDetails",
        validate,
    })(ContactDetails),
);



// WEBPACK FOOTER //
// ./src/containers/QuoteForm/ContactDetails.js